import { Menu } from "antd";
import styled from "styled-components";



export const CustomMenu = styled(Menu)`
   
`;